import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { UiComponent } from 'components';
import { UserGroupQuery } from 'queries';
import useModal from 'hooks/useModal';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { IUserGroupAddResult, IUserGroupCandidate } from 'types';
import Picker from '../Picker';
import * as UserGroupStyle from '../style';

interface Props {
  groupId: number;
}

function AddMembers({ groupId }: Props) {
  const { handleClose } = useModal();
  const { mutateAsync: addMembers, isPending } = UserGroupQuery.useAddMembers();
  const [selected, setSelected] = useState<IUserGroupCandidate[]>([]);

  const handleAdd = async () => {
    if (isPending || selected.length === 0) return;
    try {
      const res = await addMembers({
        id: groupId,
        userIds: selected.map((u) => u.id),
      });
      const { added, skipped } = res.data as IUserGroupAddResult;
      toast.success(
        `${added}명 추가 완료${skipped ? ` (이미 포함 ${skipped}명 건너뜀)` : ''}`,
      );
      handleClose();
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <div css={UserGroupStyle.modalBody}>
      <Picker selected={selected} onChange={setSelected} />
      <div css={UserGroupStyle.footer}>
        <UiComponent.Button
          variant="border"
          color="primary"
          onClick={handleClose}
        >
          취소
        </UiComponent.Button>
        <UiComponent.Button
          variant="contained"
          color="primary"
          disabled={isPending || selected.length === 0}
          onClick={handleAdd}
        >
          {`${selected.length.toLocaleString('ko')}명 추가`}
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default AddMembers;
